<template>
  <v-app>
    <v-toolbar app v-if="$session.exists()">
      <v-toolbar-title class="headline text-uppercase">
        <router-link to="/">DO</router-link>|
        <router-link to="/PO">PO</router-link>|
        <router-link to="/CUSTOMER_INVOICE">Customer INVOICE</router-link>|
        <router-link to="/FARMER_INVOICE">Farmer INVOICE</router-link>|
        <router-link to="/CN">Credit Note</router-link>|
        <router-link to="/USER">All User</router-link>|
        <router-link to="/PRODUCT">Product</router-link>|
        <router-link to="/BASKET">Basket</router-link>|
        <a href="http://chafor.net/mahsing/vege_web_v2/stock.php">Stock report</a>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-btn color="primary" @click="dialog=true">Company Profile & setting</v-btn>
      <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <setting></setting>
      </v-dialog>
    </v-toolbar>

    <v-content>
      <login v-if="!authenticated && !$session.exists()" @update="setAuthenticated()"></login>

      <router-view v-else-if="$session.exists()"></router-view>
    </v-content>
  </v-app>
</template>

<script>
// import DO from './views/Delivery_order'
import axios from "axios";
import setting from "@/components/large_component/company_info";
import baseUrl from "@/api/baseurl";
import login from "@/views/Login";

export default {
  name: "App",
  components: {
    setting,
    login
  },
  data() {
    return {
      dialog: false,
      authenticated: ""
    };
  },

  beforeCreate: function() {
    if (this.$session.exists()) {
      // this.$router.push("/PO");
      this.authenticated = true;
      console.log("HAHAHA");
      console.log(this.authenticated);
    } else {
      // this.$router.push("/login");
      this.authenticated = false;
      console.log("GGGGG");
    }
  },
  created: function() {
    if (this.$session.exists()) {
      // this.$router.push("/PO");

      this.authenticated = true;
      console.log("HAHAHA");
    } else {
      // this.$router.push("/login");
      this.authenticated = false;
      console.log("GGGGG");
    }
  },
  watch: {},
  created() {
    this.getCompanyInfo();
  },
  methods: {
    getCompanyInfo() {
      const params = new URLSearchParams();
      params.append("get_company_info", "get_company_info");

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/setting.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            localStorage.name = response.data.name;
            localStorage.address = response.data.address;
            localStorage.phone = response.data.phone;
            localStorage.fax = response.data.fax;

            if (response.data.setting_grade == "1") {
              localStorage.setting_grade = "true";
            } else {
              localStorage.setting_grade = "false";
            }
            if (response.data.setting_location == "1") {
              localStorage.setting_location = "true";
            } else {
              localStorage.setting_location = "false";
            }
            if (response.data.setting_price == "1") {
              localStorage.setting_price = "true";
            } else {
              localStorage.setting_price = "false";
            }

            localStorage.stocked_day_limit = response.data.stocked_day_limit;
          } else if (response.data.error == true) {
            console.log("gg");
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    setAuthenticated() {
      this.authenticated = true;
      console.log(this.authenticated);
    },
    logout() {
      this.authenticated = false;
    }
  }
};
</script>
